import type {
  ConferenceIndex,
  ConferenceTalkSummary,
  Talk,
} from '../../data/schema';

export interface TalkHeaderView {
  element: HTMLElement;
  updateProgress(percent: number): void;
}

function createTalkOption(
  talk: ConferenceTalkSummary,
  currentTalkId: string,
): HTMLOptionElement {
  const option = document.createElement('option');
  option.value = talk.talkId;
  option.selected = talk.talkId === currentTalkId;
  option.textContent = `${talk.speaker.name}: ${talk.title}`;
  return option;
}

export function createTalkHeader(
  talk: Talk,
  index: ConferenceIndex,
  onSelectTalk: (talkId: string) => void,
  backDestination?: { href: string; label: string },
): TalkHeaderView {
  const wrapper = document.createElement('div');
  wrapper.className = 'reader-bar';

  const inner = document.createElement('div');
  inner.className = 'reader-bar__inner';

  const back = document.createElement('a');
  back.href = backDestination?.href ?? '/';
  back.dataset.router = '';
  back.className = 'reader-back';
  back.textContent = backDestination?.label ?? `Back to ${talk.session.name}`;

  const selectLabel = document.createElement('label');
  selectLabel.className = 'talk-selector';
  const labelText = document.createElement('span');
  labelText.textContent = 'Talk';
  const select = document.createElement('select');
  select.setAttribute('aria-label', 'Choose a conference talk');
  for (const conferenceTalk of index.talks) {
    select.append(createTalkOption(conferenceTalk, talk.talkId));
  }
  select.addEventListener('change', () => {
    onSelectTalk(select.value);
  });
  selectLabel.append(labelText, select);

  const progress = document.createElement('div');
  progress.className = 'reader-progress';
  const progressLabel = document.createElement('span');
  progressLabel.textContent = '0% read';
  const track = document.createElement('span');
  track.className = 'reader-progress__track';
  const fill = document.createElement('span');
  fill.className = 'reader-progress__fill';
  track.append(fill);
  progress.append(progressLabel, track);

  inner.append(back, selectLabel, progress);
  wrapper.append(inner);

  return {
    element: wrapper,
    updateProgress(percent) {
      const rounded = Math.round(Math.min(Math.max(percent, 0), 100));
      progressLabel.textContent = `${String(rounded)}% read`;
      progress.setAttribute(
        'aria-label',
        `Reading progress: ${String(rounded)} percent`,
      );
      fill.style.width = `${String(rounded)}%`;
    },
  };
}
